import { render, staticRenderFns } from "./UserCompetitionWidget.vue?vue&type=template&id=5456ff50&scoped=true&"
import script from "./UserCompetitionWidget.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionWidget.vue?vue&type=style&index=0&id=5456ff50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456ff50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5456ff50')) {
      api.createRecord('5456ff50', component.options)
    } else {
      api.reload('5456ff50', component.options)
    }
    module.hot.accept("./UserCompetitionWidget.vue?vue&type=template&id=5456ff50&scoped=true&", function () {
      api.rerender('5456ff50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserCompetitionWidget.vue"
export default component.exports